module.exports = __webpack_public_path__ + "img/Warning.56ccd5fc.svg";